import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fav-btn",
  "use": "icon-fav-btn-usage",
  "viewBox": "-5.0 -10.0 110.0 135.0",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-5.0 -10.0 110.0 135.0\" id=\"icon-fav-btn\">\n <path d=\"m83.867 54.609-33.82 33.988-33.988-33.988c-25.953-25.949 7.8672-59.938 33.988-33.82 25.949-26.117 59.938 7.8672 33.82 33.82z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol